import Component from './index';
import { NAME } from './constants';
import reducers from './reducers';

export default {
  Component,
  name: NAME,
  reducers,
};
